export default function initSelectbox(inputName) {
    const inputs = document.querySelectorAll(`[name="${inputName}"]`)

    if (inputs) {
        inputs.forEach((input) => {
            input.addEventListener("change", () => {
                document.querySelector(input.getAttribute("value")).scrollIntoView({
                    behavior: "smooth",
                })
            })
        })
    }
}
